/* Announcement bar: shows one message at a time, arrows switch, auto-rotates. */
if (!customElements.get('dvm-announcement')) {
  customElements.define(
    'dvm-announcement',
    class DvmAnnouncement extends HTMLElement {
      connectedCallback() {
        this.messages = Array.from(this.querySelectorAll('[data-dvm-msg]'));
        if (this.messages.length < 2) return;
        this.index = 0;
        this.delay = parseInt(this.dataset.interval, 10) || 5000;
        this.querySelector('[data-dvm-prev]')?.addEventListener('click', () => this.go(-1, true));
        this.querySelector('[data-dvm-next]')?.addEventListener('click', () => this.go(1, true));
        ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => this.stop()));
        ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.start()));
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(step, fromUser) {
        const total = this.messages.length;
        this.index = (this.index + step + total) % total;
        this.messages.forEach((msg, i) => {
          const active = i === this.index;
          msg.classList.toggle('is-active', active);
          if (active) msg.removeAttribute('aria-hidden');
          else msg.setAttribute('aria-hidden', 'true');
        });
        if (fromUser) this.start();
      }

      start() {
        this.stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (this.matches(':hover') || this.contains(document.activeElement)) return;
        this.timer = setInterval(() => this.go(1, false), this.delay);
      }

      stop() {
        clearInterval(this.timer);
      }
    }
  );
}
